import React, { Suspense, lazy } from "react";

const ECET = lazy(() =>
  import("~/components/topmeteo/ECET.jsx").then((m) => ({ default: m.ShowECET, calculateECET: m.calculateECET_Meeus }))
);

export const ECETLazy = (props) => (
  <Suspense fallback={null}>
    <ECET {...props} />
  </Suspense>
);
